import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsDownload, BsPencilSquare } from "react-icons/bs";
import Id from "../../../../components/Formatters/Id";
import useDebitosPAT from "./useDebitosPAT";
import ButtonImage from "../../../../components/UI/Button/ButtonImage";
import { AuthContext, funcionalidades } from "../../../../context/AuthContext";

const formatarNuPat = (cdProcesso) => {
  if (!cdProcesso) return "";
  const parts = cdProcesso.split("/");
  if (parts.length !== 2) return cdProcesso;
  return `${parts[0].slice(-4)}/${parts[1]}`;
};

const descricaoCell = (description) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{description}</Tooltip>} data-tag="allowRowEvents">
    <Button
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#858796",
        textDecoration: "none",
        padding: 0,
      }}
      variant="link"
      data-tag="allowRowEvents"
    >
      {description}
    </Button>
  </OverlayTrigger>
);

const descricaoCellLeft = (description) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{description}</Tooltip>} data-tag="allowRowEvents">
    <Button
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#858796",
        textDecoration: "none",
        padding: 0,
        textAlign: "left",
      }}
      variant="link"
      data-tag="allowRowEvents"
    >
      {description}
    </Button>
  </OverlayTrigger>
);

const useColumns = () => {
  const { debitosPAT } = useDebitosPAT();
  const history = useHistory();
  const { isAllowed } = useContext(AuthContext);
  const funcionalidadeCiencia = isAllowed(funcionalidades.pat.cienciaIncluir);

  const columns = [
    {
      name: "Nº PAT",
      center: true,
      sortable: true,
      cell: (row) => descricaoCell(formatarNuPat(row.cdProcesso)),
      width: "10%",
    },
    {
      name: "IE",
      cell: (row) => <Id value={row.nuInscEstadual} />,
      center: true,
      width: "10%",
    },
    {
      name: "CNPJ/CPF",
      cell: (row) => <Id value={row.nuCnpj || row.nuCpf} />,
      center: true,
      width: "12%",
    },
    {
      name: "Razão Social",
      center: false,
      sortable: true,
      cell: (row) => descricaoCellLeft(row.nomeFormnal),
      width: "25%",
    },
    {
      name: "Nº Protocolo",
      center: true,
      sortable: true,
      cell: (row) => descricaoCell(row.cdPgeProcesso),
      width: "13%",
    },
    {
      name: "Situação",
      center: true,
      sortable: true,
      cell: (row) => descricaoCell(row.stProcesso),
      width: "12%",
    },
    {
      name: "Ações",
      selector: "",
      width: "13%",
      center: true,
      cell: (row) => (
        <>
          <ButtonImage
            variant="btn-link"
            className="btn-lg pa-0 p-0 mx-1"
            buttonImage={<BsDownload size="15" style={{ color: "#29e678ff" }} />}
            tooltipImage="Consolidação de Débitos"
            onClick={() => {
              debitosPAT("C", row.cdProcesso);
            }}
          />
          <ButtonImage
            variant="btn-link"
            className="btn-lg pa-0 p-0 mx-1"
            buttonImage={<BsDownload size="15" style={{ color: "#E65729" }} />}
            tooltipImage="Consolidação de Débitos Sintético"
            onClick={() => {
              debitosPAT("S", row.cdProcesso);
            }}
          />
          {funcionalidadeCiencia && (
            <ButtonImage
              variant="btn-link"
              className="btn-lg pa-0 p-0 mx-1"
              buttonImage={<BsPencilSquare size="15" style={{ color: "#4e73df" }} />}
              tooltipImage="Ciências"
              onClick={() => {
                const basePath = history.location.pathname.replace(/\/[^/]+$/, "");
                history.push({
                  pathname: `${basePath}/momentoCiencia`,
                  state: {
                    sqProcesso: row.sqProcesso,
                    cdProcesso: formatarNuPat(row.cdProcesso),
                    sqAcaoFiscal: row.sqAcaoFiscal,
                  },
                });
              }}
            />
          )}
        </>
      ),
    },
  ];

  return columns;
};

export default useColumns;
